import React from "react";
import TitleLogo from "../assets/img/title_logo.png";
import { Redirect } from 'react-router-dom'
function LogoutPage() {
  const [width, setWidth] = React.useState(window.innerWidth * 0.6);
  const [fontSize, setFontSize] = React.useState(window.innerWidth * 0.04);
  let isAuth = localStorage.getItem('user')
  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 900)
      {
        setWidth(window.innerWidth * 0.6)
        setFontSize(window.innerWidth * 0.04)
      }
      else {
        setWidth(window.innerWidth * 0.5)
        setFontSize(window.innerWidth * 0.04)
      }
    }

    window.addEventListener('resize', handleResize)
  })
  if (isAuth)
  {
    return  <Redirect to={'/home'}/>
  }
  return (
    <div className="countdown-container">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div>
          <img  alt={''} src={TitleLogo} style={{width:width * 0.7, height: 'auto'}}/>
        </div>
        <div>
          <p style={{color: 'white', fontSize: '2.1vw', marginTop: '2.1vw'}}>Thank you for joining us at the Virtual Singapore Business Awards 2020.</p>
          <p style={{color: 'white', fontSize: '2.1vw', margin: '0px',}}>See you next year!</p>
        </div>
      </div>
    </div>
  );
}
export default LogoutPage;
